import { render, staticRenderFns } from "./Type1.vue?vue&type=template&id=2c72ef59&scoped=true"
import script from "./Type1.vue?vue&type=script&lang=js"
export * from "./Type1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72ef59",
  null
  
)

export default component.exports